const CollectionSliders = () => {
  const sliderContainers = Array.from(document.querySelectorAll(".slider-container"));

  const initiateSlider = container => {
    const slides = Array.from(container.querySelectorAll(".splide"));

    slides.forEach(slide => {
      const optionElement = container.querySelector(`#${slide.dataset.options}`);
      const options = optionElement && JSON.parse(optionElement.innerHTML);
      const splide = new Splide(slide, options);
      const currentContainer = slide.closest(".tab-selection");

      if (currentContainer) {
        splide.on("ready", () => {
          const element = splide.Components.Elements.root;
          const container = element.closest(".tab-selection");
        });

        splide.on("resized", () => {
          if (Splide.STATES.IDLE) {
            const element = splide.Components.Elements.root;
            const container = element.closest(".tab-selection");
          }
        });
      }

      splide.mount();
    });
  };

  const startSliders = () => {
    if (sliderContainers.length > 0) {
      sliderContainers.forEach(container => initiateSlider(container));
    }
  };

  startSliders();
};

document.addEventListener("DOMContentLoaded", function() {
  CollectionSliders();
});